export const sources = {
	avif: "__VITE_ASSET__BxtLShhN__ 199w",
	webp: "__VITE_ASSET__C9kRsI1I__ 199w"
};
export const img = {
	src: "__VITE_ASSET__DClJY_Kh__",
	w: 199,
	h: 98
};
export default {
	sources: sources,
	img: img
};
